<mat-dialog-content>
	<mat-form-field>
		<mat-label>Wyszukaj</mat-label>
		<input matInput (keyup)="applyfilter($event.target.value)" cdkFocusInitial />
	</mat-form-field>
	<div class="form-check" *ngFor="let product of products">
		<input
			class="form-check-input"
			type="checkbox"
			id="productSelect_{{ product.id }}"
			[checked]="selected.includes(product.id)"
			(change)="change(product)"
		/>
		<label class="form-check-label" for="productSelect_{{ product.id }}">
			{{ product.name }}
		</label>
	</div>
	<button mat-button (click)="selectAll()">(zaznacz wszystkie)</button>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-stroked-button mat-dialog-close>Anuluj</button>
	<div class="spacer"></div>
	<button mat-stroked-button [mat-dialog-close]="selected" color="warn">Wybierz</button>
</mat-dialog-actions>
